import {
  Id, SelectedItem, relationshipStatuses, InterestedIn, EducationStatuses
} from '../../geo/geo.interface';

export interface DetailedSpec {
  interests?: Array<SelectedItem | Id>;
  behaviors?: Array<SelectedItem | Id>;
  relationship_statuses?: relationshipStatuses[]; // Array of enum values
  interested_in?: InterestedIn[]; // Array of enum values
  life_events?: Array<SelectedItem | Id>;
  politics?: Array<SelectedItem | Id>;
  industries?: Array<SelectedItem | Id>;
  income?: Array<SelectedItem | Id>;
  net_worth?: Array<SelectedItem | Id>;
  home_type?: Array<SelectedItem | Id>;
  home_ownership?: Array<SelectedItem | Id>;
  ethnic_affinity?: Array<SelectedItem | Id>;
  generation?: Array<SelectedItem | Id>;
  household_composition?: Array<SelectedItem | Id>;
  moms?: Array<SelectedItem | Id>;
  office_type?: Array<SelectedItem | Id>;
  education_schools?: Array<SelectedItem | Id>; // Limit: 200 education schools.
  education_statuses?: EducationStatuses[]; // Array of enum values
  college_years?: Array<number>; // Array of integers for graduation year from college. The earliest year is 1980.
  education_majors?: Array<SelectedItem | Id>; // Limit: 200 education majors.
  work_employers?: Array<SelectedItem | Id>; // Limit: 200 employers.
  work_positions?: Array<SelectedItem | Id>; // Limit: 200 work positions.
}

export interface DetailedTargetingSpec {
  flexible_spec: Array<DetailedSpec>;
  exclusions: DetailedSpec | null;
}

export const detailedSpecInitial: DetailedSpec = {
  interests:             [],
  behaviors:             [],
  relationship_statuses: [],
  interested_in:         [],
  life_events:           [],
  politics:              [],
  industries:            [],
  income:                [],
  net_worth:             [],
  home_type:             [],
  home_ownership:        [],
  ethnic_affinity:       [],
  generation:            [],
  household_composition: [],
  moms:                  [],
  office_type:           [],
  education_schools:     [],
  education_statuses:    [],
  college_years:         [],
  education_majors:      [],
  work_employers:        [],
  work_positions:        []
};

export const detailedTargetingSpecInitial: DetailedTargetingSpec = {
  flexible_spec: [{}],
  exclusions:    null
};
